import _ from 'underscore';
import { getCommonFilterConfig } from '@bingads-webui-campaign/common-grid-config';
import { getLocalizedEditorialRejectionReasons } from '@bingads-webui-campaign/url-filter-metadata';

const mockI18n = {
  get: _.identity,
  getString: _.identity,
  type: _.identity,
  enum: _.identity,
  value: _.identity,
  enumMappedString: _.identity,
  enumDescription: _.identity,
  valueDescription: _.identity,
  parseInt: _.identity,
  property: _.identity,
};
const i18nCache = {
  i18n: mockI18n,
  newI18n: mockI18n,
  legacyGlobalI18n: mockI18n,
  schemaI18nCampaign: mockI18n,
};


export function getFilterConfig({
  jsdata,
  appConfig,
  entitySchema,
  cachedEntitySchema,
  ...restParams
}) {
  // Cache i18n data, so that the DFM call can also access the correct i18n data
  _.mapObject(i18nCache, (val, key) => {
    if (restParams[key]) {
      i18nCache[key] = restParams[key];
    }
  });
  const filterConfig = getCommonFilterConfig({
    ...i18nCache,
    ...restParams,
    editor: {},
    entitySchema,
    cachedEntitySchema,
    searchbox: {
      placeholder: i18nCache.i18n.getString('Schema_Keyword_Property_Text'),
      searchProperty: 'Text',
      searchOperator: '$contains',
      maxLength: entitySchema.properties.Text.maxLength,
    },
    featureName: 'KeywordGrid',
    jsdata,
    globalConfig: appConfig,
    enableCampaignWaterfall: true,
    enableEditorialRejectionFilter: true,
    enableAdGroupWaterfall: true,
    selector: [{
      items: [
        {
          text: i18nCache.i18n.getString('AllKeyword'),
          value: null,
        },
        {
          text: i18nCache.i18n.getString('AllEnabledKeyword'),
          value: ["Enum.OrderItemStatus'Active'"],
        },
      ],
      property: 'Status',
      removable: false,
      defaultValue: null,
    }],
  });
  if (i18nCache.newI18n) {
    // update schema for rejection reasons
    const editorialRejectionFlagId = filterConfig.entitySchema.properties.EditorialRejectionFlagId;
    if (editorialRejectionFlagId && !editorialRejectionFlagId.localized) {
      editorialRejectionFlagId.localized = getLocalizedEditorialRejectionReasons(i18nCache.newI18n);
      editorialRejectionFlagId.type = 'string';
    }
  }
  return filterConfig;
}
